<template>
  <div class="grid-container pb-5">
    <div class="section-header section-header--xl section-header--dividing mt-3">
      <h1 qaid="contact-us-result-header" class="heading">{{ bp('contactUsTitle') }}</h1>
    </div>

    <Callout qaid="contact-us-result-callout" type="success" icon="info_outline">{{ bp('contactUsRespose') }}</Callout>

    <div class="buttons py-5">
      <trek-link button primary qaid="contact-us-result-submit-another" :href="`${encodedContextPath}/contact-us`">
        <span v-html="bp('submitAnother')"></span>
      </trek-link>
    </div>
  </div>
</template>
<script>
import TrekLink from '@/components/TrekLink';

export default {
  components: {TrekLink},
  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    encodedContextPath: {
      type: String,
      default: '',
    },
  },
};
</script>
